import React from "react";
import { Link } from "react-router-dom";

const DasboardItem = ({ title, link, icon }) => {
  return (
    <Link to={link}>
      <div className="flex flex-col w-[22rem]  h-56 gap-5 bg-[#D18974]/70 p-2 cursor-pointer hover:scale-110 transition ease 1s drop-shadow-2xl shadow-xl rounded-[29px]">
        <div className="flex justify-end items-center">
          <div className="w-[80px] h-[80px] m-5 flex justify-end items-start">
            {icon}
          </div>
        </div>
        <div className="flex justify-start font-semibold items-end text-[24px] m-3">
          {title}
        </div>
      </div>
    </Link>
  );
};

export default DasboardItem;
